import styled, { css } from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Força centralização absoluta, ignorando contextos de stacking */
  left: 0 !important;
  top: 0 !important;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 16px;
  min-width: 320px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  padding: 0;
  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    max-width: 95vw;
    min-width: 0;
    border-radius: 8px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
`;

export const CloseIconWrapper = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;

export const ModalContent = styled.div`
  padding: 24px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 24px 24px 24px;
`;

export const CustomButton = styled.button<{
  variant?: 'primary' | 'secondary' | 'link';
}>`
  ${({ theme, variant = 'primary' }) => css`
    padding: 12px 24px;
    border-radius: ${theme.border.radius || '8px'};
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border: 1px solid;

    ${variant === 'primary' &&
    css`
      background-color: ${theme.colors.primary50};
      color: #ffffff;
      border-color: ${theme.colors.primary50};

      &:hover {
        background-color: ${theme.colors.primary70};
        border-color: ${theme.colors.primary70};
      }
    `}

    ${variant === 'secondary' &&
    css`
      background-color: transparent;
      color: ${theme.colors.primary50};
      border-color: ${theme.colors.primary50};

      &:hover {
        background-color: ${theme.colors.primary50};
        color: #ffffff;
      }
    `}

    ${variant === 'link' &&
    css`
      background-color: transparent;
      color: ${theme.colors.primary50};
      border: none;
      padding-top: 0;
      padding-bottom: 0;
      border-radius: 0;

      /* Remove hover effects */
      &:hover {
        background-color: transparent;
        color: ${theme.colors.primary50};
      }
    `}
  `}
`;
